import { CalendarDateIcon, EyeOffIcon, FileDownload01Icon } from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  ISSUE_PERIOD_OPTIONS,
  ISSUE_STATUS_OPTIONS,
  ISSUE_TAB_ITEMS,
} from "../../_constants/issues.const";
import type { IssuePeriod, IssueStatus, IssueTypeFilter } from "../../_types/issues.types";
import styles from "./IssuesToolbar.module.scss";

type IssuesToolbarProps = {
  type: IssueTypeFilter;
  period: IssuePeriod;
  status: IssueStatus;
  onTypeChange: (value: IssueTypeFilter) => void;
  onPeriodChange: (value: IssuePeriod) => void;
  onStatusChange: (value: IssueStatus) => void;
  onExportClick: () => void;
};

export const IssuesToolbar = ({
  type,
  period,
  status,
  onTypeChange,
  onPeriodChange,
  onStatusChange,
  onExportClick,
}: IssuesToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs value={type} onChange={(value) => onTypeChange(value as IssueTypeFilter)} variant="secondary" size="medium">
          {ISSUE_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={period}
            startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onPeriodChange(value as IssuePeriod)}
          >
            {ISSUE_PERIOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={status}
            startContent={<EyeOffIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onStatusChange(value as IssueStatus)}
          >
            {ISSUE_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<FileDownload01Icon style={{ width: 20, height: 20 }} />}
          onClick={onExportClick}
        >
          Export
        </Button>
      </div>
    </div>
  );
};
